import type { LucideIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type FabProps = {
  icon: LucideIcon
  onClick: () => void
  className?: string
  /** アイコンだけで中身が伝わらないので、読み上げ用の名前を付ける */
  label?: string
}

export function Fab({ icon: Icon, onClick, className, label }: FabProps) {
  return (
    <Button
      className={cn(
        'fixed bottom-20 right-4 z-50 size-14 rounded-full shadow-lg bg-white hover:bg-neutral-100 text-black',
        className,
      )}
      onClick={onClick}
      aria-label={label}
    >
      <Icon className="size-6" />
    </Button>
  )
}
